import { render, staticRenderFns } from "./ForwardedMessagesList.vue?vue&type=template&id=32c44ceb&scoped=true"
import script from "./ForwardedMessagesList.vue?vue&type=script&lang=js"
export * from "./ForwardedMessagesList.vue?vue&type=script&lang=js"
import style0 from "./ForwardedMessagesList.vue?vue&type=style&index=0&id=32c44ceb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c44ceb",
  null
  
)

export default component.exports